import {
  customInstanceWithHeader,
  type ResponseWithHeaders,
} from '@fukuri-admins/apis/client/base/axiosInstance';
import {
  getGetApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdResultsKey,
  getGetApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdResultsUrl,
} from '@fukuri-admins/apis/client/gen/endpoints';
import type {
  GetApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdResults200,
  GetApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdResultsParams,
} from '@fukuri-admins/apis/client/gen/model';
import { useFetch } from '@fukuri-admins/hooks/common';
import type { KeyedMutator } from 'swr';

const fetcher = (
  threeLetterCode: string,
  stressAssessmentId: number,
  apiParams: GetApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdResultsParams
) =>
  customInstanceWithHeader<GetApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdResults200>(
    getGetApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdResultsUrl(
      threeLetterCode,
      stressAssessmentId,
      apiParams
    ),
    { method: 'GET' }
  );

type Args = {
  stressAssessmentId: number;
  filter: 'completed' | 'pending' | 'interview_requested';
  page: string;
};

type IUseGetStressAssessmentUserReportList = (
  threeLetterCode: string,
  args: Args
) => {
  data: GetApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdResults200;
  totalPage: number;
  totalCount: number;
  mutate: KeyedMutator<
    ResponseWithHeaders<GetApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdResults200>
  >;
};

/**
 * ストレスチェック利用者レポート一覧取得フック
 */
export const useGetStressAssessmentUserReportList: IUseGetStressAssessmentUserReportList = (
  threeLetterCode,
  args
) => {
  const { stressAssessmentId, filter, page } = args;

  const apiParams: GetApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdResultsParams =
    {
      f: filter,
      ...(page && !Number.isNaN(Number(page)) && { page: Number(page) }),
    };

  const { data, mutate } = useFetch<
    ResponseWithHeaders<GetApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdResults200>
  >(
    getGetApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdResultsKey(
      threeLetterCode,
      stressAssessmentId,
      apiParams
    ),
    () => fetcher(threeLetterCode, stressAssessmentId, apiParams),
    { suspense: true }
  );

  const totalPage = Number(data.headers['total-pages']) || 0;
  const totalCount = Number(data.headers['total-count']) || 0;

  return {
    data: data.data,
    totalPage,
    totalCount,
    mutate,
  };
};
